var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"binds-list-item-default",on:{"click":_vm.toggleControl}},[_c('binds-list-item-content',{attrs:{"binds-disabled":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }